import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useDeleteFinancialCategory(basePath) {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback(
    (categoryId) => {
      setDeleting(true);
      return quarkusApi
        .delete(`${basePath}/${categoryId}`, {
          headers: { Authorization: sessionStorage.getItem('token') },
        })
        .finally(() => setDeleting(false));
    },
    [basePath],
  );

  return { remove, isDeleting };
}
